module.exports = __webpack_public_path__ + "images/6015b41ec7b750643ed0a59bf97dc830.png";